import { useHookstate } from "@hookstate/core";
import { useLocation, useParams } from "react-router";
import { appStore } from "../../../hookstate/appStore";

export function useNewsCategories() {
  const location = useLocation();
  const { categorySlug } = useParams();

  const isVideoHub = location.pathname.includes("/watch");

  const newsCategories = useHookstate(appStore.init.news_categories).get();
  const activeCategory = newsCategories?.find(
    (category) => category.slug === (isVideoHub ? "video-hub" : categorySlug),
  );

  return { newsCategories, activeCategory };
}
